module.exports = __webpack_public_path__ + "media/images/official/top_homesimage_arrow_right-22d0aab82315d32fdbde302b467a0e0d.svg";